import React, { useState } from "react";

const locatieTipuri = ["online", "fizic"];

export default function CreeazaEveniment() {
  const [titlu, setTitlu] = useState("");
  const [descriere, setDescriere] = useState("");
  const [dataOra, setDataOra] = useState(""); // format ISO datetime-local
  const [locatieTip, setLocatieTip] = useState(locatieTipuri[0]);
  const [locatieAdresa, setLocatieAdresa] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Stil neumorphic simplu (ideal separat în CSS)
  const cardStyle = {
    background: "#f3f6fd",
    borderRadius: "20px",
    boxShadow: "6px 6px 18px #e3e6ee, -6px -6px 20px #f9faff",
    padding: "32px",
    maxWidth: "480px",
    margin: "40px auto",
  };
  const inputStyle = {
    border: "none",
    borderRadius: "12px",
    padding: "12px",
    boxShadow: "inset 3px 3px 8px #e3e6ee, inset -3px -3px 8px #fff",
    background: "#f7faff",
    fontSize: "1em",
    marginBottom: "12px",
    width: "100%",
  };
  const labelStyle = { marginBottom: 6, marginTop: 10, color: "#33418c", fontWeight: "600" };
  const btnStyle = {
    border: "none",
    borderRadius: "12px",
    background: "#285be8",
    color: "#fff",
    fontWeight: "700",
    boxShadow: "4px 4px 20px #dae3fa, -4px -4px 20px #faffff",
    padding: "14px 0",
    width: "100%",
    fontSize: "1.08em",
    marginTop: 20,
  };
  const sectionTitle = { color: "#01358D", fontWeight: 700, marginBottom: 28, marginTop: 0 };

  const trimiteEveniment = async () => {
    setError("");
    setMesaj("");

    if (!titlu || !dataOra || !locatieTip) {
      setError("Completați toate câmpurile obligatorii.");
      return;
    }
    if (locatieTip === "fizic" && !locatieAdresa.trim()) {
      setError("Pentru evenimente fizice adresa este obligatorie.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch("https://prdp-api.suport-949.workers.dev/api/evenimente", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer unwantedtok" },
        body: JSON.stringify({
          titlu,
          descriere_scurta: descriere,
          data_ora: dataOra,
          locatie_tip: locatieTip,
          locatie_adresa: locatieTip === "fizic" ? locatieAdresa : null,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setMesaj("Eveniment creat cu succes!");
        setTitlu("");
        setDescriere("");
        setDataOra("");
        setLocatieTip(locatieTipuri[0]);
        setLocatieAdresa("");
      } else {
        setError(data.error || "Eroare la crearea evenimentului.");
      }
    } catch {
      setError("Eroare de rețea sau server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={cardStyle}>
      <h2 style={sectionTitle}>Creează eveniment nou</h2>
      {error && <div style={{ color: "#e12424", marginBottom: 10 }}>{error}</div>}
      {mesaj && <div style={{ color: "#18891b", marginBottom: 10 }}>{mesaj}</div>}

      <div>
        <label style={labelStyle}>Titlu eveniment *</label>
        <input style={inputStyle} value={titlu} onChange={(e) => setTitlu(e.target.value)} />
      </div>

      <div>
        <label style={labelStyle}>Scurtă descriere</label>
        <textarea
          style={{ ...inputStyle, minHeight: 80, resize: "vertical" }}
          value={descriere}
          onChange={(e) => setDescriere(e.target.value)}
        />
      </div>

      <div>
        <label style={labelStyle}>Data și ora evenimentului *</label>
        <input
          type="datetime-local"
          style={inputStyle}
          value={dataOra}
          onChange={(e) => setDataOra(e.target.value)}
        />
      </div>

      <div>
        <label style={labelStyle}>Tip locație *</label>
        <select style={inputStyle} value={locatieTip} onChange={(e) => setLocatieTip(e.target.value)}>
          {locatieTipuri.map((lt) => (
            <option key={lt} value={lt}>
              {lt === "fizic" ? "Fizic" : "Online"}
            </option>
          ))}
        </select>
      </div>

      {locatieTip === "fizic" && (
        <div>
          <label style={labelStyle}>Adresă locație *</label>
          <input style={inputStyle} value={locatieAdresa} onChange={(e) => setLocatieAdresa(e.target.value)} />
        </div>
      )}

      <button type="button" style={btnStyle} onClick={trimiteEveniment} disabled={loading}>
        {loading ? "Salvează..." : "Salvează eveniment"}
      </button>
    </div>
  );
}
